import { render, staticRenderFns } from "./BreadcrumbTrail.vue?vue&type=template&id=56ce0c8b&scoped=true"
import script from "./BreadcrumbTrail.vue?vue&type=script&lang=ts"
export * from "./BreadcrumbTrail.vue?vue&type=script&lang=ts"
import style0 from "./BreadcrumbTrail.vue?vue&type=style&index=0&id=56ce0c8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ce0c8b",
  null
  
)

export default component.exports